// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nxz3","field":"styles_field__1s22q","fieldCol":"styles_fieldCol__2VnGj","diffCol":"styles_diffCol__3JjfL","diff":"styles_diff__2zFYw"};